/**
 * @requires parameter must be the original record set for the query.
 * @returns The cache key for the parameter
 */
export const getCacheParameterKey = <T extends Record<string, any>>(parameter: T): string => {
  return JSON.stringify(parameter);
};
